var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcImageHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M17.6 4H6.4C5.04 4 4 5.04 4 6.4v11.2C4 18.96 5.04 20 6.4 20h11.2c1.36 0 2.4-1.04 2.4-2.4V6.4C20 5.04 18.96 4 17.6 4zm-12 2.4c0-.48.32-.8.8-.8h11.2c.48 0 .8.32.8.8v6.08l-2.64-2.64a.773.773 0 0 0-1.12 0l-8.48 8.48a.768.768 0 0 1-.56-.72V6.4zm12 12H8.32l6.88-6.88 3.2 3.2v2.88c0 .48-.32.8-.8.8zm-8.4-7.2c1.12 0 2-.88 2-2s-.88-2-2-2-2 .88-2 2 .88 2 2 2zm0-2.4c.24 0 .4.16.4.4 0 .24-.16.4-.4.4-.24 0-.4-.16-.4-.4 0-.24.16-.4.4-.4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#9cc100",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImageHover);
export default __webpack_public_path__ + "static/media/ic-image-hover.0faecd3dda4de3c24655c7e63217d79c.svg";
export { ForwardRef as ReactComponent };